enum NotificationStatus {
    NEW = "NEW",
    VISUALIZED = "VISUALIZED",
    READ = "READ"
}

export default NotificationStatus;